import React, { Component, PropTypes } from 'react';
import { getDataAttributes } from 'utils/utils';
import shouldPureComponentUpdate from 'react-pure-render/function';
import * as optimizelyUtil from 'utils/optimizely';
import './BookInput.scss';

// Read more here about the autofill https://cloudfour.com/thinks/autofill-what-web-devs-should-know-but-dont/
export default class BookInput extends Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.string,
    autoComplete: PropTypes.string,
    placeholder: PropTypes.string,
    onFieldChange: PropTypes.func.isRequired,
    onFieldBlur: PropTypes.func,
    onKeyDown: PropTypes.func,
    isValid: PropTypes.bool,
    message: PropTypes.string,
    isSmall: PropTypes.bool,
    data: PropTypes.object,
    type: PropTypes.string,
    autoCapitalize: PropTypes.string,
    pattern: PropTypes.string,
    nameForAutoComplete: PropTypes.string,
    formName: PropTypes.string.isRequired,
    isRequiredField: PropTypes.bool,
  };

  static defaultProps = {
    isValid: null,
    data: {},
    type: 'text',
    autoCapitalize: 'none',
    value: '',
    isRequiredField: false,
  }

  componentDidMount() {
    this.checkInputValue();
  }

  shouldComponentUpdate = shouldPureComponentUpdate;

  componentWillUnmount() {
    window.clearTimeout(this.timeout);
  }

  sixtyFPS = 1000 / 60;

  checkInputValue = () => {
    if (this.input && this.previousValue !== this.input.value) {
      this.previousValue = this.input.value;

      const evt = window.document.createEvent('HTMLEvents');
      evt.initEvent('input', true, true);
      this.input.dispatchEvent(evt);
    }
    this.timeout = window.setTimeout(this.checkInputValue, this.sixtyFPS);
  }

  fireOptimizelyEvent = () => {
    const { data } = this.props;

    if (data.optimizelyId) {
      optimizelyUtil.fireEvent(`BookInput${data.optimizelyId}`, 'clicked');
    }
  }

  refInput = input => this.input = input;

  input = {};

  render() {
    const { label,
      value,
      placeholder,
      autoComplete,
      onFieldChange,
      onFieldBlur,
      isValid,
      message,
      isSmall,
      data,
      onKeyDown,
      type,
      autoCapitalize,
      pattern,
      nameForAutoComplete,
      formName,
      isRequiredField,
    } = this.props;

    /* eslint-disable */
    if (__DEBUG__ && /[^a-z0-9]/i.test(formName)) console.error('Invalid formName: it must be one single word');
    /*eslint-enable */

    const sectionName = /[^a-z0-9]/i.test(formName) ? '' : `section-${formName} `;
    const autoCompleteValue = !autoComplete || autoComplete === 'off' ? 'off' : `${sectionName}${autoComplete}`;

    return (
      <div className={`book-input ${isValid === false ? 'book-input--invalid' : ''} ${isSmall ? 'book-input--small' : ''} ${isValid ? 'book-input--valid' : ''}`}>
        <label>
          <span className="book-input__label">{label}{isRequiredField ? '*' : ''}</span>
          <span className="book-input__input-wrap">
            <input
              className="book-input__input"
              type={type}
              value={this.input.value || value}
              onChange={onFieldChange}
              onBlur={onFieldBlur}
              onFocus={this.fireOptimizelyEvent}
              onKeyDown={onKeyDown}
              placeholder={placeholder}
              autoComplete={autoCompleteValue}
              name={nameForAutoComplete}
              ref={this.refInput}
              autoCapitalize={autoCapitalize}
              pattern={pattern}
              {...getDataAttributes(data)}
            />
          </span>
          {isValid === false && <span className="book-input__message">{message}</span>}
        </label>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/BookInput/BookInput.jsx
 **/